import { css } from '@emotion/react';
import { colors } from './colors';
import { agBorderColor } from './ag-foresight';

export const GRID_ROW_HEIGHT = 42;
export const COMPACT_GRID_ROW_HEIGHT = 28;

export const gridAutoHeightCss = css`
  /* https://www.ag-grid.com/javascript-data-grid/grid-size/#min-height-with-auto-height */
  .ag-grid-scrolling-rows {
    min-height: unset !important;
  }
`;

export const gridCenterHeaderCss = css`
  .ag-header-cell-label {
    justify-content: center;
  }
`;

export const cellEditorWrapperCss = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  &:has(.MuiSwitch-root) {
    height: 100%;
    flex-direction: row;
    align-items: center;
  }

  & .MuiFormControl-root {
    margin: 0 !important;
  }
`;
export const errorRowClass = 'error-row';
export const editableCellClass = 'editable-cell';
export const rowWithInvalidDataClass = 'ag-row-invalid';
export const editableGridCss = css`
  & .ag-row.${errorRowClass} {
    background: ${colors.critical[50]}05;
  }

  & .${editableCellClass} {
    background: ${colors.primary[20]}18;
  }

  & .${errorRowClass} {
    & .${editableCellClass} {
      background: ${colors.critical[50]}05;
    }
  }

  & .ag-row-hover .${editableCellClass} {
    outline: 1px solid ${agBorderColor};
  }

  &&&& .MuiAutocomplete-inputRoot {
    background: ${colors.primary[0]};
    min-width: 100%;
  }

  &&&&& .${rowWithInvalidDataClass} {
    background-color: ${colors.critical[5]};
  }
`;

export const negativeValueCss = css`
  &&&&&& .negative {
    color: var(--mui-palette-error-main);
  }
`;

export const nonEditableCellClass = 'cell-edit-disabled';
export const nonEditableCellCss = css`
  &&&& .${nonEditableCellClass} {
    color: var(--mui-palette-text-secondary);
  }
`;
/** A value that is not confirmed yet (an AI extraction managed services have not replaced). */
export const provisionalCellClass = 'cell-provisional';
export const provisionalCellCss = css`
  &&&& .${provisionalCellClass} {
    color: var(--mui-palette-text-secondary);
  }
`;
/** A provisional value drawn on its own: the number greyed over a dotted underline, and nothing else. */
export const provisionalValueCss = css`
  color: var(--mui-palette-text-secondary);
  text-decoration: underline dotted;
  /* a fine line as designed: the font's own thickness draws about 2px on a high-density screen */
  text-decoration-thickness: 1px;
  /* clear of the commas, so the dots read as a mark rather than part of the number */
  text-underline-offset: 0.2em;
`;
/** A calculated value drawn on its own: the number greyed; the underline is what sets a provisional one apart. */
export const calculatedValueCss = css`
  color: var(--mui-palette-text-secondary);
`;
export const nonEditableRowClass = 'row-edit-disabled';
export const nonEditableRowCss = css`
  &&&& .${nonEditableRowClass} {
    background: ${colors.secondary[5]};
    color: var(--mui-palette-text-secondary);
  }
`;

export const disabledCheckboxCss = css`
  &&&&&& .ag-checkbox-input-wrapper {
    &:where(.ag-disabled) {
      filter: grayscale();
      opacity: 0.2;
      pointer-events: none;
    }
  }
`;
